import MinimumCqlScoreWidget from './../MinimumCqlScoreWidget'
import { withProps } from 'recompose'
import { getEloquaConfig, patchEloquaConfig } from 'app/modules/integrations/api'

export const model = [
  {
    type: 'syncContactsEnabled',
    value: false,
    label: 'Sync leads from Drift to Eloqua',
    description: 'Leads from Drift will be created or updated in Eloqua whenever a conversation closes',
  },
  {
    type: 'shouldSetLeadOwner',
    value: false,
    label: 'Set Salesperson in Eloqua',
    description: 'For every new contact that Drift creates, we can set a Salesperson (if the Salesperson field is currently empty) based on who had a meeting booked, who was routed, or who closed the conversation in that order.',
  },
  {
    type: 'shouldOnlySyncQualifiedContacts',
    value: false,
    label: 'Set a minimum CQL score for synced contacts and conversations',
    description: 'Unchecked, Drift will sync all contacts and conversations to Eloqua except those that have been disqualified.',
    children: {
      autoExpand: true,
      label: 'Minimum CQL score',
      description: 'Drift will only sync conversations that have the selected CQL score or higher.',
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        integrationName: 'eloqua',
        setMinimumCQLScore: (data) => {
          return patchEloquaConfig({ "minimumCQLScore" : data.score })
        },
        getMinimumCQLScore: () => {
          return getEloquaConfig()
        }
      })(MinimumCqlScoreWidget),
      items: []
    }
  },
  {
    type: 'syncConversationTranscriptsEnabled',
    value: false,
    label: 'Sync CDOs from Drift to Eloqua',
    description: "Push data to an Eloqua CDO of your choice. You can configure what data gets sent in the 'Mapped CDO Attributes' section",
  },
  {
    type: 'cookieIdentificationEnabled',
    value: false,
    label: 'Identify Drift visitors with the Eloqua cookie',
    description:  `If someone was already identified by Eloqua, Drift will automatically recognize them as a known contact. We'll only check Eloqua if the visitor has an Eloqua cookie set.`,
  }
]

export const hydrateModel = toggles => {
  return [...model].map(topLevel => {
    const updatedToggle = Object.assign({}, topLevel)
    updatedToggle.value = toggles[topLevel.type]
    return updatedToggle
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/EloquaConfig/model.js